module.exports = __webpack_public_path__ + "img/gjort-til-grin-3.4ae23bd7.png";